import { FC, useState } from 'react';
import s from './form.module.scss';
import { DeliveryDetails } from '@components/Pages/PaymentsPages/Withdraw/Form/DeliveryDetails/DeliveryDetails';
import { payoutInputType } from '@specs/views';
import { Summary } from '@components/Pages/PaymentsPages/Withdraw/Form/Summary/Summary';
import { RubyAmount } from '@components/Pages/PaymentsPages/Withdraw/Form/RubyAmount/RubyAmount';
import { KYC } from '@components/Pages/PaymentsPages/Withdraw/Form/KYC/KYC';
import { kycData } from '@specs/specs';
import { LogoLoader } from '@components/UIKit/LogoLoader/LogoLoader';
import { useGetProfileWithKyc } from '@hooks/TRPC_Hooks/useGetIsKycAvailable';
export type StateType = Omit<payoutInputType, 'price'> & {
  price: number | '';
};

// TODO тип ругаетя, говорит нужен  hodername, почему линтер пропустил?
//@ts-ignore
export const defaultState: StateType = {
  price: '',
  country: '',
  bankName: '',
  accountNumber: '',
  swiftCode: '',
  iban: ''
};
interface Props {}
export const getKycStatus = (kyc: kycData | null) => kyc === null || kyc === undefined ? undefined : kyc.status === 'pending' && !kyc?.result ? 'review' : kyc.result === 'GREEN' ? 'completed' : kyc.result === 'RED' ? 'error' : undefined;
export const Form: FC<Props> = ({}) => {
  const [formState, setFormState] = useState<StateType>(defaultState);
  const {
    data: profile,
    isLoading: profileLoading
  } = useGetProfileWithKyc();
  const changeFromData = <T extends keyof StateType,>(key: T, value: StateType[T]) => {
    setFormState(prev => ({
      ...prev,
      [key]: value
    }));
  };
  const isLoading = profileLoading;
  if (isLoading) return <LogoLoader />;
  if (!profile) return null;
  const {
    kyc,
    ruby
  } = profile;
  const kycStatus = getKycStatus(kyc);
  return <div className={s.form} data-sentry-component="Form" data-sentry-source-file="Form.tsx">
            <div className={s.form__left}>
                <RubyAmount price={formState.price} changeFromData={changeFromData} ruby={ruby} data-sentry-element="RubyAmount" data-sentry-source-file="Form.tsx" />
                <KYC kycStatus={kycStatus} ruby={ruby} data-sentry-element="KYC" data-sentry-source-file="Form.tsx" />
            </div>
            <div className={s.form__details}>
                <DeliveryDetails formState={formState} changeFromData={changeFromData} data-sentry-element="DeliveryDetails" data-sentry-source-file="Form.tsx" />
            </div>
            <div className={s.form__summary}>
                <Summary formState={formState} kycStatus={kycStatus} setFormState={setFormState} data-sentry-element="Summary" data-sentry-source-file="Form.tsx" />
            </div>
        </div>;
};